export default "__VITE_ASSET__Cp80HaM8__"